import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de959b1f4e8dda/src/layout/home/homeContent.tsx");
